<template>
    <Stepper :pt="{nav: {class: 'hidden'}}">
        <StepperPanel v-for="(review, index) in reviews">
            <template #content="{ prevCallback, nextCallback }">
                <h4>{{ $t('lang.pages.qualification.finish.reviews_title') }}</h4>
                <div class="flex">
                    <div>
                        <img class="step_finally_reviews__avatar" :src="review.avatar_small" alt="" />
                    </div>
                    <div>
                        <h5 class="step_finally_reviews__name" v-html="review.name"></h5>
                        <span class="block text-sm">{{ review.positions.join(', ') }}</span>
                        <div v-if="review.links" v-html="getLinks(review)" class="mt-2 flex flex-wrap column-gap-3"></div>
                        <template v-if="review.custom_links">
                            <div class="mt-2 flex flex-wrap column-gap-3">
                                <a
                                    v-for="link in review.custom_links"
                                    :href="link.url"
                                    target="_blank"
                                    class="flex flex-wrap gap-1 align-items-center text-sm text-primary no-underline mb-1"
                                >
                                    <img :src="link.icon" />
                                    <span>{{ link.text }}</span>
                                </a>

                            </div>
                        </template>
                    </div>
                </div>
                <p v-html="review.text"></p>
                <QualificationStepsNavigationContent
                    v-bind="navigationCallbacks(index + 1, prevCallback, nextCallback)"
                />
            </template>
        </StepperPanel>
    </Stepper>
</template>

<script>
import Stepper from "primevue/stepper";
import StepperPanel from "primevue/stepperpanel";
import QualificationStepsNavigationContent from "./StepsNavigationContent.vue";

export default {
    name: "StepFinallyReviews",
    props: {
        reviews: {
            type: Array,
            required: true,
        }
    },
    methods: {
        navigationCallbacks(slideNumber, prevCallback, nextCallback) {
            let callbacks = {};
            if (slideNumber !== 1) {
                callbacks['callback-prev'] = prevCallback;
            }
            if (slideNumber !== this.reviews.length) {
                callbacks['callback-next'] = nextCallback;
            }

            return callbacks;
        },
        getLinks(review) {
            let html = '';
            review.links.forEach(link => {
                const url = (new URL(link));
                html += sprintf('<a href="%s" target="_blank" class="flex flex-wrap gap-1 align-items-center text-sm text-primary no-underline mb-1">', url.href);
                switch (url.hostname) {
                    case 't.me':
                        html += sprintf(
                            '<img src="/i/icons/telegram-grey.svg" /> <span>@%s</span>',
                            url.pathname.replace(/^\//g, '')
                        );
                        break;
                    case 'www.youtube.com':
                        html += sprintf(
                            '<img src="/i/icons/youtube-grey.svg" /> <span>%s</span>',
                            url.pathname.replace(/^\//g, '')
                        );
                        break;
                    default: {
                        html += sprintf(
                            '<img src="/i/icons/web-grey.svg" /> <span>%s</span>',
                            url.hostname
                        );
                    }
                }

                html += '</a>'
            });

            return html;
        },
    },
    components: {
        Stepper,
        StepperPanel,
        QualificationStepsNavigationContent,
    }
}
</script>

<style scoped>
h5 {
    margin: 6px 0;
    font-weight: 700;
}
.step_finally_reviews__avatar {
    border-radius: 50%;
    width: 75px;
    margin-right: 20px;
    height: 75px;
    object-fit: cover;
    object-position: center;
}
</style>
